var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.contract.no))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.contract.title))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.contract.sndPartyRealComName))])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form label" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-3x" },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.acntPeriodFormChange },
                  model: {
                    value: _vm.contract.acntPeriodForm,
                    callback: function($$v) {
                      _vm.$set(_vm.contract, "acntPeriodForm", $$v)
                    },
                    expression: "contract.acntPeriodForm"
                  }
                },
                [
                  _vm.payPeriodTypesAllowed.indexOf(2) > -1
                    ? _c("el-radio", { attrs: { label: 2 } }, [
                        _c("span", [_vm._v("阶段间隔天数")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.payPeriodTypesAllowed.indexOf(1) > -1
                    ? _c("el-radio", { attrs: { label: 1 } }, [
                        _c("span", [_vm._v("账期")])
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        { ref: "contractPhasedPaySettingList", attrs: { model: _vm.contract } },
        [
          _c("table", { staticClass: "custom-tbl error-prompt" }, [
            _c("thead", { staticClass: "head" }, [
              _c("tr", { staticClass: "row" }, [
                _c("th", { staticClass: "text-align: left; required" }, [
                  _vm._v("阶段名称")
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "text-align: left; required",
                    attrs: { width: "200" }
                  },
                  [_vm._v("阶段类型")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "text-align: right; required",
                    attrs: { width: "200" }
                  },
                  [_vm._v("账期起算规则")]
                ),
                _vm._v(" "),
                _vm.contract.acntPeriodForm == 1
                  ? _c(
                      "th",
                      {
                        staticClass: "text-align: right; required",
                        attrs: { width: "100" }
                      },
                      [_vm._v("账期(天)")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.acntPeriodForm == 2
                  ? _c(
                      "th",
                      {
                        staticClass: "text-align: right; required",
                        attrs: { width: "140" }
                      },
                      [_vm._v("当期阶段间隔天数")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "text-align: left; required",
                    attrs: { width: "200" }
                  },
                  [_vm._v("金额计算依据")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "text-align: left; required",
                    attrs: { width: "120" }
                  },
                  [_vm._v("付款比例(%)")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "text-align: right; required",
                    attrs: { width: "150" }
                  },
                  [_vm._v("支付方式")]
                ),
                _vm._v(" "),
                _c("th", { attrs: { width: "100" } }, [_vm._v("操作")])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "body" },
              _vm._l(_vm.contract.contractPhasedPaySettingList, function(
                item,
                index
              ) {
                return _c("tr", { staticClass: "row" }, [
                  item.showPhaseNameAndPhaseType
                    ? _c(
                        "td",
                        { attrs: { rowspan: item.rowspanNum } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractPhasedPaySettingList." +
                                  index +
                                  ".phaseName",
                                rules: {
                                  validator: _vm.checkNull,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "fl",
                                staticStyle: { width: "80%" },
                                attrs: { type: "text" },
                                on: {
                                  blur: function($event) {
                                    _vm.phaseNameChange(index)
                                  }
                                },
                                model: {
                                  value: item.phaseName,
                                  callback: function($$v) {
                                    _vm.$set(item, "phaseName", $$v)
                                  },
                                  expression: "item.phaseName"
                                }
                              }),
                              _vm._v(" "),
                              item.rowspanNum < _vm.payMethodList.length
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "swb-btn-link fr inline-block",
                                      on: {
                                        click: function($event) {
                                          _vm.addPaySetting(item, index)
                                        }
                                      }
                                    },
                                    [_vm._v("增加付款次数")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.showPhaseNameAndPhaseType
                    ? _c(
                        "td",
                        { attrs: { rowspan: item.rowspanNum } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractPhasedPaySettingList." +
                                  index +
                                  ".phaseType",
                                rules: {
                                  validator: _vm.checkNull,
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  on: {
                                    change: function($event) {
                                      _vm.phaseTypeChange(index)
                                    }
                                  },
                                  model: {
                                    value: item.phaseType,
                                    callback: function($$v) {
                                      _vm.$set(item, "phaseType", $$v)
                                    },
                                    expression: "item.phaseType"
                                  }
                                },
                                _vm._l(_vm.phaseTypeList, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.text,
                                      value: item.value
                                    }
                                  })
                                })
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.showPhaseNameAndPhaseType
                    ? _c(
                        "td",
                        { attrs: { rowspan: item.rowspanNum } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractPhasedPaySettingList." +
                                  index +
                                  ".acntPeriodBasis",
                                rules: {
                                  validator: _vm.checkNull,
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  on: {
                                    change: function($event) {
                                      _vm.acntPeriodBasisChange(index)
                                    }
                                  },
                                  model: {
                                    value: item.acntPeriodBasis,
                                    callback: function($$v) {
                                      _vm.$set(item, "acntPeriodBasis", $$v)
                                    },
                                    expression: "item.acntPeriodBasis"
                                  }
                                },
                                _vm._l(_vm.acntPeriodStartTPList, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.text,
                                      value: item.value
                                    }
                                  })
                                })
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.acntPeriodForm == 1 &&
                  item.showPhaseNameAndPhaseType
                    ? _c(
                        "td",
                        {
                          staticClass: "text-right",
                          attrs: { rowspan: item.rowspanNum }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractPhasedPaySettingList." +
                                  index +
                                  ".acntPeriodDays",
                                rules: {
                                  validator: _vm.checkNull,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "number", min: 0 },
                                on: {
                                  blur: function($event) {
                                    _vm.acntPeriodDaysChange(index)
                                  }
                                },
                                model: {
                                  value: item.acntPeriodDays,
                                  callback: function($$v) {
                                    _vm.$set(item, "acntPeriodDays", $$v)
                                  },
                                  expression: "item.acntPeriodDays"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.acntPeriodForm == 2 &&
                  item.showPhaseNameAndPhaseType
                    ? _c(
                        "td",
                        {
                          staticClass: "text-right",
                          attrs: { rowspan: item.rowspanNum }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractPhasedPaySettingList." +
                                  index +
                                  ".phaseGapDays",
                                rules: {
                                  validator: _vm.checkNull,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "number", min: 0 },
                                on: {
                                  blur: function($event) {
                                    _vm.phaseGapDaysChange(index)
                                  }
                                },
                                model: {
                                  value: item.phaseGapDays,
                                  callback: function($$v) {
                                    _vm.$set(item, "phaseGapDays", _vm._n($$v))
                                  },
                                  expression: "item.phaseGapDays"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop:
                              "contractPhasedPaySettingList." +
                              index +
                              ".calcBasis",
                            rules: {
                              validator: _vm.checkNull,
                              trigger: "change"
                            }
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: item.calcBasis,
                                callback: function($$v) {
                                  _vm.$set(item, "calcBasis", $$v)
                                },
                                expression: "item.calcBasis"
                              }
                            },
                            _vm._l(_vm.amtCalcMethodList, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.text, value: item.value }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop:
                              "contractPhasedPaySettingList." +
                              index +
                              ".ratio",
                            rules: { validator: _vm.checkNull, trigger: "blur" }
                          }
                        },
                        [
                          _c("el-input", {
                            on: {
                              blur: function($event) {
                                _vm.ratioChange(index)
                              }
                            },
                            model: {
                              value: item.ratio,
                              callback: function($$v) {
                                _vm.$set(item, "ratio", $$v)
                              },
                              expression: "item.ratio"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop:
                              "contractPhasedPaySettingList." +
                              index +
                              ".payMethod",
                            rules: {
                              validator: _vm.checkNull,
                              trigger: "change"
                            }
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              on: {
                                change: function($event) {
                                  _vm.payMethodChange(index)
                                }
                              },
                              model: {
                                value: item.payMethod,
                                callback: function($$v) {
                                  _vm.$set(item, "payMethod", $$v)
                                },
                                expression: "item.payMethod"
                              }
                            },
                            _vm._l(_vm.payMethodList, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.text, value: item.value }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "div",
                      {
                        staticClass: "swb-btn swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.removeContractPhasedPaySetting(index)
                          }
                        }
                      },
                      [_c("span", [_vm._v("移除")])]
                    )
                  ])
                ])
              })
            ),
            _vm._v(" "),
            _c("tfoot", { staticClass: "foot" }, [
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      padding: "10px",
                      border: "1px solid #dfe6ec",
                      "text-align": "center"
                    },
                    attrs: { colspan: "8" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "swb-btn swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.addContractPhasedPaySetting()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "icon iconfont icon-jiahao mr5"
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("添加阶段")])
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("合同信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("系统合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("付款阶段")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("付款账期形式")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efe40416", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efe40416","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractPhasedPaySettingModify.vue
// module id = 3251
// module chunks = 0